import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { Subscription } from 'rxjs';
import {UserVerificationService} from "../../services/user-verification.service";
import {NetworkServerModel} from "../../models/network-server.model";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {HttpService} from "../../services/http.service";
import {ApiEndpoints} from "../../services/api-endpoints";

@Component({ standalone: false, 
  selector: 'app-input-edit',
  templateUrl: './input-edit.component.html',
})
export class InputEditComponent implements OnInit, OnDestroy {

  public networkServerModel: NetworkServerModel;
  public errorMessage;
  public hasError = false;
  isAdmin: boolean = false;
  inputIsDisable = true;
  inputIsHidden = false;
  nameExist = false;
  nsIdExist = false;
  public class = ["ng-valid", "ng-touched", "ng-dirty"];
  public urlArray : any[] = [];
  @Input() saveType;
  @Input() fns_url;
  @Input() js_url;
  @Input() sns_url;
  @Input() hns_url;
  @Input() claim_url;
  @Input() inputValue;
  @Input() virtId;
  @Input() validationType;
  @Input() formType;


  isAdminSubscription: Subscription;
  httpSubscription: Subscription;

  constructor(private userVerificationService: UserVerificationService,
              private http: HttpClient,
              private httpService: HttpService) {

    this.networkServerModel = new NetworkServerModel();

    this.isAdminSubscription = userVerificationService.message.subscribe(res => this.isAdmin = res);
  }

  inputOnClick(inputCheck) {
    inputCheck.classList.remove(...this.class);
    if(this.saveType != 'url_js' && this.saveType != 'url_claim' && this.formType == 'NS') {
      this.httpSubscription = this.httpService.getNetworkInfo(this.virtId).subscribe(data => {
        this.urlArray[0] = data.url_fns;
        this.urlArray[1] = data.url_sns;
        this.urlArray[2] = data.url_hns;
      });
    }
    this.inputIsDisable = false;
    this.inputIsHidden = true;
    inputCheck.classList.remove('disabled');
  }

  inputOnSave(inputCheck) {
    let tempValue = inputCheck.value.trim();
    const headers = new HttpHeaders({'Content-Type':  'application/json'});
    let options =  {headers: headers};
    var url = '';
    var body: any = {};
    switch (this.saveType) {
      case 'name':
        switch (this.formType) {
          case 'RC':
            url = ApiEndpoints.UPDATE_RC_NAME;
            body = {
              "virtId": this.virtId,
              "name": tempValue
            };
            break;
          default:
            url = ApiEndpoints.UPDATE_NAME;
            body = {
              "virtId": this.virtId,
              "name": tempValue
            };
        }
        break;
      case 'nsId':
        url = ApiEndpoints.UPDATE_NS_ID;
        body = {
          "virtId": this.virtId,
          "nsId": tempValue
        };
        break;
      case 'subscriberId':
        url = ApiEndpoints.UPDATE_SUBSCRIBER_ID;
        body = {
          "virtId": this.virtId,
          "subscriberId": tempValue
        };
        break;
      case 'url_fns':
        url = ApiEndpoints.UPDATE_URL_FNS;
        body = {
          "virtId": this.virtId,
          "url_fns": tempValue
        };
        break;
      case 'url_sns':
        url = ApiEndpoints.UPDATE_URL_SNS;
        body = {
          "virtId": this.virtId,
          "url_sns": tempValue
        };
        break;
      case 'url_hns':
        url = ApiEndpoints.UPDATE_URL_HNS;
        body = {
          "virtId": this.virtId,
          "url_hns": tempValue
        };
        break;
      case 'url_js':
        url = ApiEndpoints.UPDATE_URL_JS;
        body = {
          "virtId": this.virtId,
          "url_js": tempValue
        };
        break;
      case 'url_claim':
        url = ApiEndpoints.UPDATE_URL_CLAIM;
        body = {
          "virtId": this.virtId,
          "url_claim": tempValue
        };
        break;
      case 'authUsername':
          url = ApiEndpoints.UPDATE_AUTH_USERNAME;
          body = {
            "virtId": this.virtId,
            "authUsername": tempValue
          };
        break;
      case 'authPassword':
          url = ApiEndpoints.UPDATE_AUTH_PASSWORD;
          body = {
            "virtId": this.virtId,
            "authPassword": tempValue
          };
        break;
    }
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.inputIsDisable = true;
          this.inputIsHidden = false;
          this.inputValue = tempValue;
          this.hasError = false;
          this.errorMessage = "";
          inputCheck.classList.add('disabled');
        },
        error => {
          try {
            let err = JSON.parse(error._body);
            this.errorMessage = JSON.stringify(err.Description);
          } catch(ex) {
            this.errorMessage = "An error has occured!"
          } finally {
            this.hasError = true;
          }
        }
      );
  }

  inputOnCancel(inputCheck) {
    inputCheck.value = this.inputValue;
    this.inputIsDisable = true;
    this.inputIsHidden = false;
    this.hasError = false;
    inputCheck.classList.add('disabled');
  }


  trimValue(event) {
    event.target.value = event.target.value.replace(/\s\s+/g, ' ')
  }

  testValidation(inputCheck,inputElement,event: any) {
    switch (this.validationType) {
      case 'name':
        this.hasError = false;
        if (inputCheck.trim().length == 0) {
          this.errorMessage = "Name is required.";
          this.hasError = true;
        } else if (inputCheck.length >= 40) {
          this.errorMessage = "Name must have maximum 40 characters.";
          this.hasError = true;
        } else {
          const headers = new HttpHeaders({'Content-Type':  'application/json'});
          let options =  {headers: headers};
          var url = "";
          switch (this.formType) {
            case 'RC':
              url = ApiEndpoints.EXISTS_RC_NAME
              break;
            default:
              url = ApiEndpoints.EXISTS_NAME;
          }
          inputCheck = inputCheck.replace(/\s\s+/g, ' ');
          inputCheck = inputCheck.trim();
          let body = {
            "name": inputCheck,
            "type": this.formType
          };
          this.http.post<any>(url, body, options).subscribe(
              data => {
                this.hasError = data.response;
                this.errorMessage = "This name already exists in database"
              }
            );
          inputElement.classList.add(...this.class);
        }
        break;

      case 'subscriberId':
        this.hasError = false;
        if (inputCheck.trim().length > 80) {
          this.errorMessage = "SubscriberID must be a hex string no longer than 80 characters";
          this.hasError = true;
        }
        break;

      case 'nsId':
        this.hasError = false;
        let nsIdRegExp = new RegExp(/^([0-9a-fA-F]{16})$/i);
        if (inputCheck.trim().length == 0) {
          this.errorMessage = "NS ID is required.";
          this.hasError = true;
        } else if (!nsIdRegExp.test(inputCheck.trim())) {
          this.errorMessage = "NS ID must be a 16 character hex string";
          this.hasError = true;
        } else {
          const headers = new HttpHeaders({'Content-Type':  'application/json'});
          let options =  {headers: headers};
          var url = ApiEndpoints.EXISTS_NSID;
          let body = {
            "virtId": this.virtId,
            "nsId": inputCheck.trim()
          };
          this.http.post<any>(url, body, options).subscribe(
              data => {
                this.hasError = data.response;
                this.errorMessage = "This NS ID already exists in database"
              }
            );
          inputElement.classList.add(...this.class);
        }
        break;

      case 'url':
        let urlRegExp =  new RegExp(/^(([a-zA-Z-][a-zA-Z0-9-]{1,63}(\.[a-zA-Z-][a-zA-Z0-9-]{1,63})+)|((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[1-9])(\b|\.)(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])(\b|\.)(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])(\b|\.)(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[1-9])\b))(\:(102[4-9]|10[3-9][0-9]|1[1-9][0-9][0-9]|[2-9][0-9][0-9][0-9]|[1-5][0-9][0-9][0-9][0-9]|6[0-4][0-9][0-9][0-9]|65[0-4][0-9][0-9]|655[0-2][0-9]|6553[0-5])\b)?(((\/){0,1}[a-zA-Z-0-9\_\-])*(::)?([a-zA-Z-0-9\_\-])*)*(\/){0,1}$/);

        if (inputCheck === "") {
          this.httpSubscription = this.httpService.getNetworkInfo(this.virtId).subscribe(data => {
            this.urlArray[0] = data.url_fns;
            this.urlArray[1] = data.url_sns;
            this.urlArray[2] = data.url_hns;
          });
          inputElement.classList.remove(...this.class);
          switch(this.saveType) {
            case 'url_fns':
              if(this.urlArray[1] == null && this.urlArray[2] == null) {
                this.hasError = true;
                this.errorMessage = "You must have at least one URL";
              } else {
                this.hasError = false;
              }
              break;
            case 'url_sns':
              if(this.urlArray[0] == null && this.urlArray[2] == null) {
                this.hasError = true;
                this.errorMessage = "You must have at least one URL";
              } else {
                this.hasError = false;
              }
              break;
            case 'url_hns':
              if(this.urlArray[0] == null && this.urlArray[1] == null) {
                this.hasError = true;
                this.errorMessage = "You must have at least one URL";
              } else {
                this.hasError = false;
              }
              break;
          }

        } else if(!urlRegExp.test(inputCheck)) {
          this.errorMessage = "Url is invalid."
          this.hasError = true;
        } else {
          this.hasError = false;
          inputElement.classList.add(...this.class);
        }
        break;
      case 'url_js':
        let url_jsRegExp = new RegExp(/^(([a-zA-Z-][a-zA-Z0-9-]{1,63}(\.[a-zA-Z-][a-zA-Z0-9-]{1,63})+)|((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[1-9])(\b|\.)(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])(\b|\.)(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])(\b|\.)(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[1-9])\b))(\:(102[4-9]|10[3-9][0-9]|1[1-9][0-9][0-9]|[2-9][0-9][0-9][0-9]|[1-5][0-9][0-9][0-9][0-9]|6[0-4][0-9][0-9][0-9]|65[0-4][0-9][0-9]|655[0-2][0-9]|6553[0-5])\b)?(((\/){0,1}[a-zA-Z-0-9\_\-])*(::)?([a-zA-Z-0-9\_\-])*)*(\/){0,1}$/);

        if(inputCheck === ""){
          this.hasError = true;
          this.errorMessage = "Url is required";
        } else if(!url_jsRegExp.test(inputCheck)) {
          this.errorMessage = "Url is invalid."
          this.hasError = true;
        } else {
          this.hasError = false;
          inputElement.classList.add(...this.class);
        }
        break;
      case 'url_claim':
        let url_claimRegExp = new RegExp(/^(([a-zA-Z-][a-zA-Z0-9-]{1,63}(\.[a-zA-Z-][a-zA-Z0-9-]{1,63})+)|((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[1-9])(\b|\.)(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])(\b|\.)(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])(\b|\.)(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[1-9])\b))(\:(102[4-9]|10[3-9][0-9]|1[1-9][0-9][0-9]|[2-9][0-9][0-9][0-9]|[1-5][0-9][0-9][0-9][0-9]|6[0-4][0-9][0-9][0-9]|65[0-4][0-9][0-9]|655[0-2][0-9]|6553[0-5])\b)?(((\/){0,1}[a-zA-Z-0-9\_\-])*(::)?([a-zA-Z-0-9\_\-])*)*(\/){0,1}$/);
        if(inputCheck === "") {
          this.hasError = false;
          inputElement.classList.add(...this.class);
        } else if(!url_claimRegExp.test(inputCheck)) {
          this.errorMessage = "Url is invalid."
          this.hasError = true;
        } else {
          this.hasError = false;
          inputElement.classList.add(...this.class);
        }
        break;
      case 'alarm':
        let alarmRegExp = new RegExp('^[1-9][0-9]*$');
        if (inputCheck === "") {
          this.errorMessage = "Alarm threshold is required.";
          this.hasError = true;
        } else if (!alarmRegExp.test(inputCheck) || inputCheck > 10000000) {
          this.errorMessage = "Alarm threshold must be between 1 and 10000000.";
          this.hasError = true;
        } else {
          this.hasError = false;
          inputElement.classList.add(...this.class);
        }
        break;
      case 'authUsername':
        this.hasError = false;
        if (inputCheck === "") {
          this.errorMessage = "Auth username is required.";
          this.hasError = true;
        }
        break;
      case 'authPassword':
        this.hasError = false;
        if (inputCheck === "") {
          this.errorMessage = "Auth password is required.";
          this.hasError = true;
        }
        break;
    }
  }

  ngOnInit() {
    this.urlArray[0] = this.fns_url;
    this.urlArray[1] = this.sns_url;
    this.urlArray[2] = this.hns_url;
  }

  ngOnDestroy() {
    this.isAdminSubscription.unsubscribe();
  }
}
